import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StaffCard.css";

class Address extends Component {
  render() {
    const { classes, staff } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>Temporary Address</h3>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>VDC</div>
            <div>{staff.temporaryAddress.vdc}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>District</div>
            <div>{staff.temporaryAddress.district}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>City</div>
            <div>{staff.temporaryAddress.city}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Province</div>
            <div>{staff.temporaryAddress.province}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Country</div>
            <div>{staff.temporaryAddress.country}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Nationality</div>
            <div>{staff.temporaryAddress.nationality}</div>
          </ListItem>
          <br />
          <h3>Permanent Address</h3>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>VDC</div>
            <div>{staff.permanentAddress.vdc}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>District</div>
            <div>{staff.permanentAddress.district}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>City</div>
            <div>{staff.permanentAddress.city}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Province</div>
            <div>{staff.permanentAddress.province}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Country</div>
            <div>{staff.permanentAddress.country}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Nationality</div>
            <div>{staff.permanentAddress.nationality}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Address);
